export enum RoutesSelfieEnum {
  GET_READY = 'selfie-get-ready' as any,
  FRONTAL_STAGE = 'selfie-frontal-stage' as any,
  FRONTAL_PHOTO = 'selfie-frontal-photo' as any,
  INCLINED_STAGE = 'selfie-inclined-stage' as any,
  INCLINED_PHOTO = 'selfie-inclined-photo' as any,
  SELFIE_ERROR = 'selfie-error' as any
}
